<template>
  <header
    id="header"
    class="header"
    :class="{ '--is-dark' : isDark }"
  >
    <div class="header__top">
      <div class="componata-container">
        <ul class="header__shortcuts --is-left">
          <li class="header__shortcut">
            <a href="/mein-konto/"><i class="icon icon-user"></i> Kunden—Login</a>
          </li>
          <li class="header__shortcut">
            <a href="tel:+49034198992080" v-on:click="trackPhone"><i class="icon icon-phone"></i> 0341 9899 2080</a>
          </li>
          <li class="header__shortcut">
            <a href="mailto:kundenservice@componata.de" v-on:click="trackMail"><i class="icon icon-envelope"></i> kundenservice@componata.de</a>
          </li>
        </ul>

        <ul class="header__shortcuts --is-right">
          <li class="header__shortcut">
            <a href="/warenkorb/"><i class="icon icon-shopping-cart"></i> Warenkorb</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="header__main" :class="{ '--is-expanded' : isMobileNavShown }">
      <div class="componata-container">
        <button class="header__btn --is-cart"><i class="icon icon-shopping-cart"></i></button>

        <h1 class="header__logo">
          <a href="/" title="Homepage">
            <img
              v-if="isDark"
              src="@/assets/images/logo-w.svg"
              alt="Componata"
            >

            <img
              v-else
              src="@/assets/images/logo-b-w.svg"
              alt="Componata"
            >
          </a>
        </h1>

        <button class="header__btn --is-menu" @click.stop="toggleMobileNav()"><i v-if="isMobileNavShown === false" class="icon icon-bars"></i><i v-else class="icon icon-times"></i></button>

        <ul class="header__nav">
          <li class="header__nav-item" :class="{ '--is-active' : $route.path.search('/fertige') !== -1 }"><router-link :to="cLink('/fertige')">Fertige Präsente</router-link></li>
          <li class="header__nav-item" :class="{ '--is-active' : $route.path.search('/zusammenstellen') !== -1 }"><router-link :to="cLink('/zusammenstellen')">Selbst zusammenstellen</router-link></li>
          <li class="header__nav-item"><a href="/praesente/contact">Individuelle Anfrage</a></li>
          <li class="header__nav-item"><a href="/praesente/b2b/pages/geburtstagsgeschenk-mitarbeiter-und-jubilaeum">Mitarbeitergeburtstage / Jubiläum</a></li>
           <!-- <li class="header__nav-item"><a href="/firmenkunden/">Firmenkunden</a></li> -->
          <li class="header__nav-item"><a href="/praesente/b2b/pages/firmengeschenke/">Firmenpräsente</a></li>
          <li class="header__nav-item"><a href="/praesente/b2b/pages/weihnachten">Weihnachten</a></li>
        </ul>
      </div>
    </div>

    <div v-if="isMobileNavShown" class="header__mobile">
      <div class="header__nav-group">

        <!-- <h4 class="header__nav-group-title">Componata</h4> -->

        <ul class="header__nav-list">
          <li class="header__nav-item" :class="{ '--is-active' : $route.path == '' || $route.path.search('/fertige') !== -1 }"><router-link :to="cLink('/fertige')">Fertige Präsente</router-link></li>
          <li class="header__nav-item" :class="{ '--is-active' : $route.path.search('/zusammenstellen') !== -1 }"><router-link :to="cLink('/zusammenstellen')">Selbst zusammenstellen</router-link></li>
          <!-- <li class="header__nav-item"><a href="/firmenkunden">Firmenkunden</a></li> -->
          <li class="header__nav-item"><a href="/individuelle-anfrage/">Individuelle Anfrage</a></li>
          <!-- <li class="header__nav-item"><a href="/weihnachtspraesente-massgeschneidert-von-componata/">Weihnachten</a></li> -->
          <!-- <li class="header__nav-item" :class="{ '--is-active' : $route.path.search('/pages/weihnachten') !== -1 }"><router-link to="/b2b/pages/weihnachten">Weihnachten</router-link></li> -->
          <li class="header__nav-item"><a href="/praesente/b2b/pages/geburtstagsgeschenk-mitarbeiter-und-jubilaeum">Mitarbeitergeburtstage / Jubiläum</a></li>
          <li class="header__nav-item"><a href="/praesente/b2b/pages/firmengeschenke">Firmenpräsente</a></li>
          <li class="header__nav-item"><a href="/praesente/b2b/pages/weihnachten">Weihnachten</a></li>
        </ul>
      </div>

      <div class="header__nav-group">
        <h4 class="header__nav-group-title">Sie Kontakt mit uns auf</h4>

        <ul class="header__nav-list">
          <li class="header__nav-item">
            <a href="/mein-konto/"><i class="icon icon-user"></i> Kunden Login</a>
          </li>
          <li class="header__nav-item">
            <a href="tel:+49034198992080"><i class="icon icon-phone"></i> 0341 9899 2080</a>
          </li>
          <li class="header__nav-item">
            <a href="mailto:kundenservice@componata.de"><i class="icon icon-envelope"></i> kundenservice@componata.de</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="$store.getters.getNoticeBanner.isActive && !this.$store.getters.getNoticeBanner.forbiddenUrls.some(v => window.location.href.includes(v))"
      :class="`header__notice --is-${$store.getters.getNoticeBanner.color}`"
    >
      <div class="componata-container" v-html="this.$store.getters.getNoticeBanner.message"></div>
    </div>
  </header>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'TheHeader',
  mixins: [logicMixin, helperMixin],
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isMobileNavShown: false,
      window: window,
      customerType: ''
    };
  },
  methods: {
    toggleMobileNav () {
      if (this.isMobileNavShown === false) {
        this.isMobileNavShown = true;
        document.querySelector('body').style.setProperty('overflow', 'hidden');
      } else {
        this.isMobileNavShown = false;
        document.querySelector('body').style.removeProperty('overflow');
      }
    },

    toggleCustomerType (type) {
      if (type) {
        this.customerType = type;
      } else {
        this.customerType = this.customerType === 'b2c' ? 'b2b' : 'b2c';
      }

      // Delay the actual switch so the animation of the toggle is completed
      setTimeout(() => {
        this.switchCustomerType(type);
      }, 10);

      this.trackEvent(this.customerType === 'b2c' ? 'setB2c' : 'setB2b', { source: 'Toggle' });
    },
    trackMail() {
      this.trackEvent('mailContactClicked');
    },
    trackPhone() {
      this.trackEvent('phoneContactClicked');
    },
    trackEvent(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        campaing: this.landingPageName
      });
    }
  },
  mounted () {
    this.customerType = this.$store.getters.isB2b ? 'b2b' : 'b2c';
  },
  destroyed () {
    document.querySelector('body').style.removeProperty('overflow');
  }
};
</script>

<style lang="scss" scoped>
/**
 * Header
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc App Header
 * @since 2020-04-24
**/

$component: 'header';
$spacer: 28px;

.#{$component} {
  position: relative;
  width: 100%;
  height: auto;
  @include font-size($font-size-base);
  background-color: $white;
  background: $white;
  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
              0 1px 3px 0 rgba(63, 63, 68, 0.15);
  z-index: 14;

  &__top {
    @include padding-top(map-get($spacers, 2));
    @include padding-bottom(map-get($spacers, 2));
    border-bottom: 1px solid $gray-ghost;
    @include font-size($font-size-sm);

    > .componata-container {
      display: flex;
      justify-content: space-between;
    }
  }

  &__shortcuts {
    @include unlist;
    display: flex;
  }

  &__shortcut {
    display: block;
    color: $ink-lighter;

    &:not(:first-child) {
      @include margin-left(map-get($spacers, 4));
    }

    a {
      color: $ink-lighter;
      text-decoration: none;

      @include hover () {
        color: $ink-light;

        .icon {
          color: $ink-light;
        }
      }
    }

    .icon {
      position: relative;
      color: $ink-lighter;
      @include font-size($font-size-lg);
      vertical-align: text-bottom;

      .notification-bubble {
        position: absolute;
        top: -7px;
        right: -10px;
        border: 2px solid $white;
        transform: scale(0.9);
      }
    }

    &.--has-notification {
      .icon {
        margin-right: 7px;
      }
    }
  }

  &__main {
    > .componata-container {
      display: flex;
      align-items: center;
    }
  }

  &__logo {
    display: block;
    margin: 0;

    a {
      display: block;
    }

    img {
      display: block;
      width: auto;
      height: 38px;
      @include margin-top(- map-get($spacers, 2));
    }
  }

  &__nav {
    @include unlist;
    display: flex;
    @include margin-left(map-get($spacers, 6));
  }

  &__nav-item {
    border-bottom: 3px solid transparent;

    &:not(:last-child) {
      margin-right: 1px;
    }

    @include hover() {
      &:not(.--is-active):hover {
        border-bottom-color: $sky-dark;
      }
    }

    a {
      display: block;
      @include padding-right(map-get($spacers, 3)/1.25);
      @include padding-left(map-get($spacers, 3)/1.25);
      padding-top: $spacer;
      padding-bottom: ($spacer - 3px);
      color: $ink;
      text-decoration: none;

      @include hover () {
        color: $ink;
      }
    }

    &.--is-active {
      border-bottom-color: $primary;
      font-weight: $font-weight-bold;
    }
  }

  &__btn {
    display: none;
    // position: absolute;
    margin: 0;
    padding: 0;
    border: 0;
    line-height: 1;
    background: none;

    .icon {
      @include font-size($font-size-lg * 2.4);
      line-height: 1;
    }
  }

  &__notice {
    @include padding(map-get($spacers, 2) 0);
    @include font-size($font-size-sm);
    text-align: center;
    // border-top: 2px solid $yellow;
    // background-color: lighten($yellow, 19);
    // border-top: 2px solid $blue;
    background-color: lighten($blue, 54%);
    // background-color: lighten($green, 42%);

    &.--is-blue {
      background-color: lighten($blue, 54%);
    }

    &.--is-green {
      background-color: #dbffe7;
    }

    &.--is-yellow {
      background-color: #fff7d0;
    }

    &.--is-red {
      background-color: #ffd8dc;
    }

    ::v-deep p {
      margin: 0;
    }
  }

  &__etc {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  // Customer Type Chooser
  &__chooser {
    position: relative;

    @include hover () {
      .#{$component} {
        &__chooser-face {
          box-shadow: 0 2px 8px rgba(black, 0.2);
          // box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
              // 0 1px 3px 0 rgba(63, 63, 68, 0.15);
        }

        &__chooser-options {
          display: block;
        }
      }
    }

    &-face {
      display: flex;
      align-items: flex-end;
      @include padding(map-get($spacers, 2) map-get($spacers, 2));
      border-radius: $border-radius-lg;
      background-color: #fff;
      cursor: pointer;

      svg {
        width: 32px;
        height: 32px;
        @include margin-right(map-get($spacers, 2));
        color: $green;
      }

      div {
        display: flex;
        flex-direction: column;
        line-height: 1;

        small {
          color: $ink-lighter;
          @include font-size($font-size-sm / 1.2);
        }
      }

      .icon {
        // align-self: flex-end;
      }
    }

    &-options {
      display: none;
      position: absolute;
      right: 0;
      @include padding-top(map-get($spacers, 2));
    }

    &-duplex {
      display: flex;
      border-radius: $border-radius-lg;
      box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05),
              0 1px 3px 0 rgba(63, 63, 68, 0.15);
      background-color: white;
    }

    &-type {
      width: 12rem;
      @include padding(map-get($spacers, 3));
      cursor: pointer;

      &:first-child {
        border-right: 1px solid rgba($ink, 0.1);
      }

      header {
        display: flex;
        flex-direction: column;
        @include margin-bottom(map-get($spacers, 2));
        line-height: 120%;

        br {
          display: none;
        }

        > div {
          display: flex;
          align-items: center;
          @include margin-bottom(map-get($spacers, 2));

          > span {
            display: flex;
            align-items: center;
            @include margin-left(map-get($spacers, 2));
            color: $ink-lighter;
            @include font-size($font-size-sm);
          }

          .icon {
            @include margin-right(map-get($spacers, 1));
            border-radius: 50%;
            background-color: $green;
            color: white;
            @include font-size($font-size-base);
            line-height: 1;
          }
        }

        svg {
          width: 32px;
          height: 32px;
        }

        small {
          color: $ink-lighter;
          @include font-size($font-size-sm / 1.2);
        }
      }

      content {
        display: block;
        width: 100%;

        ul {
          @include unlist;
          @include margin-left(- map-get($spacers, 1));

          li {
            display: flex;
            align-items: center;

            &:before {
              content: '\e911';
              display: block;
              color: $ink-lighter;
              font-family: 'icomoon';
              @include font-size($font-size-lg * 1.1);
              @include margin-right(map-get($spacers, 0));
            }
          }
        }
      }

      &.--is-b2c {
        border-top-left-radius: $border-radius-lg;
        border-bottom-left-radius: $border-radius-lg;
        background: linear-gradient(to top, #F1FFE3, 60%, #fff 100%);

        content li:before {
          color: $green;
        }

        @include hover () {
          background: linear-gradient(to top, darken(#F1FFE3, 2%) 60%, #fff 100%);
        }
      }

      &.--is-b2b {
        border-top-right-radius: $border-radius-lg;
        border-bottom-right-radius: $border-radius-lg;
        background: linear-gradient(to top, #E2F3FF 60%, #fff 100%);

        content li:before {
          color: $blue;
        }

        @include hover () {
          background: linear-gradient(to top, darken(#E2F3FF, 2%) 60%, #fff 100%);
        }
      }
    }

    // Alternative (simplified) version
    &.--is-alt-version {
      .#{$component} {
        &__chooser-face {
          align-items: center;
        }
      }
    }
  }

  // Customer Type Switcher
  &__switcher {
    display: flex;
    align-items: center;

    > b {
      color: $ink-lightest;
      font-weight: normal;
      cursor: pointer;
    }

    &-toggle {
      align-self: auto;
      width: 40px;
      @include margin(0 map-get($spacers, 2));
      padding: 3px;
      border-radius: 50px;
      background-color: $ink;
      cursor: pointer;

      &:after {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: $white;
        box-shadow: 1px 1px 4px rgba($ink, 0.3);
        transition: all 0.250s ease;
      }
    }

    &.--is-b2c {
      b:first-child {
        color: $ink;
      }

      .#{$component}__switcher-toggle {
        background-color: $green;

        &:after {
          transform: translateX(0);
        }
      }

      @include hover () {
        .#{$component}__switcher-toggle {
          background-color: darken($green, 2%);

          &:after {
            box-shadow: 1px 1px 4px rgba($ink, 0.5);
            // transform: translateX(2px);
          }
        }
      }
    }

    &.--is-b2b {
      b:last-child {
        color: $ink;
      }

      .#{$component}__switcher-toggle {
        background-color: $blue;

        &:after {
          transform: translateX(18px);
        }
      }

      @include hover () {
        .#{$component}__switcher-toggle {
          background-color: darken($blue, 2%);

          &:after {
            box-shadow: -1px 1px 4px rgba($ink, 0.5);
            // transform: translateX(16px);
          }
        }
      }
    }
  }

  // Mobile
  &__mobile {
    display: none;
  }

  // Dark
  &.--is-dark {
    background: linear-gradient(180deg, rgba(19, 19, 19, 0.44) 13.01%, rgba(19, 19, 19, 0) 100%);
    box-shadow: none;

    .#{$component} {
      &__top {
        border-bottom-color: rgba($white, 0.07);
      }

      &__switcher {
        > b {
          color: rgba($white, 0.4);
        }

        &.--is-b2c b:first-child {
          color: rgba($white, 0.8);
        }

        &.--is-b2b b:last-child {
          color: rgba($white, 0.8);
        }
      }

      &__shortcut {
        color: $ink-lightest;

        a {
          color: rgba($white, 0.4);

          &:hover,
          &:hover .icon {
            color: rgba($white, 0.7);
          }
        }

        .icon {
          color: rgba($white, 0.3);
        }
      }

      &__nav-item {
        @include hover() {
          &:not(.--is-active):hover {
            border-bottom-color: rgba($white, 0.4);
          }
        }

        a {
          color: $sky-lighter;
          padding-bottom: 14px;
        }
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($legacy-vars, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($legacy-vars, 'viewport-md')) {
    @include rfs(map-get($spacers, 2), --mobileLogoOffset);

    &__top,
    &__main &__nav,
    &__etc {
      display: none;
    }

    &__switcher {
      justify-content: center;
      @include margin-bottom(map-get($spacers, 3));

      > b {
        line-height: 1;
        font-weight: $font-weight-bold;

        &:first-child {
          text-align: right;
        }

        &:last-child {
          text-align: left;
        }

        br {
          display: none;
        }

        small {
          display: block;
          @include margin-bottom(map-get($spacers, 1) / 2);
          color: $ink-lighter;
          font-weight: $font-weight-normal;
        }
      }

      &-toggle {
        @include margin(0 map-get($spacers, 3));
      }
    }

    &__main {
      display: flex;
      align-items: center;
      @include rfs(5rem, height);

      > .componata-container {
        width: 100%;
        justify-content: space-between;
        align-items: center;
      }
    }

    &__logo img {
        width: auto;
        @include rfs(3rem, height);
        @include margin-top(- map-get($spacers, 1) !important);
    }

    &__btn {
      display: block;
      top: 0rem;

      &.--is-menu {
        @include rfs(map-get($spacers, 3), left);
        @include margin-top(0.3rem);
      }

      &.--is-cart {
        @include rfs(map-get($spacers, 3), right);
      }
    }

    // Nav
    &__nav,
    &__shortcuts {
      flex-direction: column;
      margin: 0;
    }

    &__nav-item,
    &__shortcut {
      margin: 0 !important;
      border-bottom-width: 0;
      border-bottom: 1px solid $gray-ghost;

      &.--is-active {
        border-bottom-color: $gray-ghost;
        font-weight: $font-weight-bold;

        a {
          border-left-color: $primary;
        }

        &:first-child a {
          border-top-left-radius: $border-radius-lg;
        }

        &:last-child a {
          border-bottom-left-radius: $border-radius-lg;
        }
      }

      a {
        display: block;
        @include padding(map-get($spacers, 2) map-get($spacers, 3) map-get($spacers, 2) 0.8rem !important);
        border-left: 3px solid transparent;
      }
    }

    // Mobile nav
    &__mobile {
      display: block;
      position: fixed;
      // @include rfs(5rem, top);
      left: 0;
      right: 0;
      height: calc(100vh);
      overflow-x: hidden;
      overflow-y: scroll;
      @include padding(map-get($spacers, 3));
      border-top: 1px solid $gray-ghost;
      background-color: $white;
      // z-index: 120;
    }

    &__nav-group {
      & + & {
        @include margin-top(map-get($spacers, 5));
      }

      &:last-child {
        @include margin-bottom(10rem);
      }
    }

    &__nav-list {
      @include unlist;
      border: 1px solid $gray-ghost;
      border-radius: $border-radius-lg;
    }

    &__nav-item {
      &:last-child {
        border-bottom: none;
      }

      .icon {
        width: 20px;
        height: 20px;
        @include margin-right(map-get($spacers, 1));
        vertical-align: middle;
        @include font-size($font-size-base * 1.6);

        ::v-deep svg {
          display: block;
          width: 100%;
          height: auto;
        }
      }
    }

    // Dark
    &.--is-dark {
      .#{$component} {
        &__btn {
          color: $sky-lighter;
          outline: none;
        }

        &__main.--is-expanded {
          background-color: $ink;
        }

        &__mobile {
          border-top-color: rgba($ink-light, 0.5);
          background-color: $ink;
        }

        &__nav-list {
          border-color: rgba($ink-light, 0.5);
        }

        &__nav-item,
        &__shortcut {
          border-bottom-color: rgba($ink-light, 0.5);
        }
      }
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($legacy-vars, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($legacy-vars, 'viewport-xs')) {
  }
}
</style>
